import { render, staticRenderFns } from "./FormPrecioPlazosComponent.vue?vue&type=template&id=21ac1030"
import script from "./FormPrecioPlazosComponent.vue?vue&type=script&lang=js"
export * from "./FormPrecioPlazosComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports